import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * A titled section: a name and a line saying what you are looking at.
 *
 * The line is not decoration — a grid of allowlist entries does not explain on its own
 * why a Conflicts column matters, or that these are every organization's entries
 * rather than one customer's.
 *
 * No slot for controls. Both grids put theirs in their own command strip, next to
 * Filters and Manage Columns, so everything that acts on a table sits in one row.
 */
export function SectionHeading({ title, description }: { title: string; description: ReactNode }) {
  return (
    <Stack spacing={0.25} sx={{ mb: 0.5, minWidth: 0 }}>
      <Typography variant="subtitle1" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Stack>
  );
}
